/** @format */

import { request } from '@/utils/request';

// 新增模块列表
export function addModule(data) {
	return request(
		{
			url: `powerportal/v1/module`,
			type: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询模块管理列表
export function getModuleList(query) {
	return request(
		{
			url: `powerportal/v1/module/list`,
			type: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询模块管理详情
export function getModule(moduleId) {
	return request(
		{
			url: `powerportal/v1/module/${moduleId}`,
			type: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 修改模块管理
export function updateModule(data) {
	return request(
		{
			url: `powerportal/v1/module`,
			type: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 删除模块列表
export function removeModule(moduleId) {
	return request(
		{
			url: `powerportal/v1/module/${moduleId}`,
			type: 'delete',
		},
		{
			isGetDataDirectly: false,
		},
	);
}
